"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useBackStep = require("./useBackStep");
Object.keys(_useBackStep).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useBackStep[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useBackStep[key];
    }
  });
});
